import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { clinicInvoiceServiceTypesDataSource } from 'infrastructure/data-sources/clinic-invoice-service-types';

import type { IClinicInvoiceServiceTypeItem } from 'infrastructure/data-sources/clinic-invoice-service-types';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IClinicInvoiceServiceTypeItem['id'],
  IClinicInvoiceServiceTypeItem
>[];

interface IProps extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClinicInvoiceServiceTypeSelectBox: React.FC<IProps> = (props) => {
  const dataSource = useMemo(() => clinicInvoiceServiceTypesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClinicInvoiceServiceTypeSelectBox;
